export const EX_JSON = {
    Mission: {
        daily: [
            `[
  {
    "Index" : 1,
    "TargetCampaigns" : [1,2],
    "RequiredTime" : 600,
    "OpenAt" : 1,
    "TokenType" : 1,
    "TokenAmount" : 1000000000000000000
  },
  {
    "Index" : 2,
    "TargetCampaigns" : [1,2],
    "RequiredTime" : 600,
    "OpenAt" : 1,
    "TokenType" : 1,
    "TokenAmount" : 1000000000000000000
  },
  /...
]`
        ],
        achieve: [
            `[
  {
  "Index": 1,
  "MissionCondition": 1,
  "TokenType": 1,
  "TokenAmount": 1000000000000000000
  },
  {
  "Index": 2,
  "MissionCondition": 1,
  "TokenType": 1,
  "TokenAmount": 1000000000000000000
  },
  // ...
]`
        ],
    },
    Raffle: {
        jsonRoundInfo: [
            '[\n' +
            '   {\n' +
            '     "round": 1,\n' +
            '     "open_count": 0,\n' +
            '     "price_per": 0,\n' +
            '     "price_xper": 1000000000000000000,\n' +
            '     "item_ticket": true\n' +
            '   },\n' +
            '   {\n' +
            '     "round": 2,\n' +
            '     "open_count": 10,\n' +
            '     "price_per": 1000000000000000000,\n' +
            '     "price_xper": 0,\n' +
            '     "item_ticket": true\n' +
            '   },\n' +
            '   {\n' +
            '     "round": 3,\n' +
            '     "open_count": 30,\n' +
            '     "price_per": 1500000000000000000,\n' +
            '     "price_xper": 2500000000000000000,\n' +
            '     "item_ticket": false\n' +
            '   }\n' +
            ']'
        ],
        jsonRewardInfo: [
            '[\n' +
            '  {\n' +
            '    "round_no": 3,\n' +
            '    "key_type": true,\n' +
            '    "reward_type": 1,\n' +
            '    "item_id": NFT번호입력해주세요,\n' +
            '    "item_count": 1,\n' +
            '    "item_init_count": 1\n' +
            '  },\n' +
            '  {\n' +
            '    "round_no": 2,\n' +
            '    "key_type": true,\n' +
            '    "reward_type": 0,\n' +
            '    "item_id": 10014,\n' +
            '    "item_count": 2,\n' +
            '    "item_init_count": 4\n' +
            '  },\n' +
            '  {\n' +
            '    "round_no": 1,\n' +
            '    "key_type": false,\n' +
            '    "reward_type": 0,\n' +
            '    "item_id": 4001,\n' +
            '    "item_count": 1,\n' +
            '    "item_init_count": 10\n' +
            '  },\n' +
            '  {\n' +
            '    "round_no": 1,\n' +
            '    "key_type": false,\n' +
            '    "reward_type": 0,\n' +
            '    "item_id": 3001,\n' +
            '    "item_count": 3,\n' +
            '    "item_init_count": 10\n' +
            '  },\n' +
            '  {\n' +
            '    "round_no": 1,\n' +
            '    "key_type": false,\n' +
            '    "reward_type": 2,\n' +
            '    "item_id": 1,\n' +
            '    "item_count": 100000000000000000,\n' +
            '    "item_init_count": 25\n' +
            '  },\n' +
            '  {\n' +
            '    "round_no": 1,\n' +
            '    "key_type": false,\n' +
            '    "reward_type": 2,\n' +
            '    "item_id": 2,\n' +
            '    "item_count": 200000000000000000,\n' +
            '    "item_init_count": 25\n' +
            '  },\n' +
            '  {\n' +
            '    "round_no": 1,\n' +
            '    "key_type": false,\n' +
            '    "reward_type": 2,\n' +
            '    "item_id": 2,\n' +
            '    "item_count": 500000000000000000,\n' +
            '    "item_init_count": 25\n' +
            '  }\n' +
            ']'
        ],
        jsonBonusReward: [
            '[\n' +
            '    {\n' +
            '        "required_pulls": 10,\n' +
            '        "item_id": 101,\n' +
            '        "item_count": 1\n' +
            '    },\n' +
            '    {\n' +
            '        "required_pulls": 20,\n' +
            '        "item_id": 102,\n' +
            '        "item_count": 2\n' +
            '    },\n' +
            '    {\n' +
            '        "required_pulls": 50,\n' +
            '        "item_id": 103,\n' +
            '        "item_count": 3\n' +
            '    },\n' +
            '    {\n' +
            '        "required_pulls": 100,\n' +
            '        "item_id": 104,\n' +
            '        "item_count": 4\n' +
            '    }\n' +
            ' // ...' +
            ']'
        ],
    },
    ItemShop : {
        itemInfo: `{
     "Category": 0,
     "ItemId": 0,
     "ItemCount": 0,
     "PriceType": 0,
     "InitPrice": 0,
     "Price": 0,
     "LimitType": 0,
     "PurchaseLimit": 0,
     "SaleLimit": 0,
     "Status": 0,
     "Sort": 0,
     "StartedAt": "0000-00-00T00:00:00",
     "EndedAt": "0000-00-00T00:00:00"
}
`
    },
    GoogleStore : {
        itemInfo:                   `{
     "ProductId": "",
     "ProductName": "",
     "ProductType": 0,
     "ItemList": "",
     "Status": 0,
     "LimitType": 0,
     "PurchaseLimit": 0,
     "SaleLimit": 0,
     "TypeCode": 0,
     "Sort": 0,
     "StartedAt": "0000-00-00T00:00:00",
     "EndedAt": "0000-00-00T00:00:00"
}
`
    }
};